import { Boxed, isBoxed, unbox } from 'ngrx-forms';

export const appUnbox = <T>(value: T): T extends Boxed<infer U> ? U : T =>
  // @ts-expect-error
  isBoxed(value) ? unbox(value) : value;
